// export const BASE_URL_API = "https://cors-anywhere.herokuapp.com/https://admin.stylelink.in/apis";
export const BASE_URL_API = "https://admin.stylelink.in/apis";
// export const BASE_URL_NOTIFICATIONS = "https://cors-anywhere.herokuapp.com/https://api.sne.stylelink.in/api/notification";
export const BASE_URL_NOTIFICATIONS = "https://api.sne.stylelink.in/api/notification";